import type { NoticeItem } from "@/pages/notification/data";

function stripHtml(html: string) {
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function NotificationDetail({ notification }: { notification?: NoticeItem }) {
  if (!notification) {
    return (
      <div className="ntf-detailEmpty">
        <div className="ntf-detailEmptyTitle">Select a notice</div>
        <div className="ntf-detailEmptySubtitle">
          Choose one from the list to view details.
        </div>
      </div>
    );
  }

  const isHtml = typeof notification.description === "string" && /<\/?[a-z][\s\S]*>/i.test(notification.description);

  return (
    <article className="ntf-detail">
      <h2 className="ntf-detailTitle">{notification.title}</h2>
      {isHtml ? (
        <div
          className="ntf-detailBody"
          dangerouslySetInnerHTML={{ __html: notification.description ?? "" }}
        />
      ) : (
        <p className="ntf-detailBody">
          {notification.description ? stripHtml(notification.description) : "No details available."}
        </p>
      )}
    </article>
  );
}

